import { api } from '@/shared/lib/api'
import type { BranchOffice, BranchFormData } from '../types'

export const branchService = {
  getAll: async (): Promise<BranchOffice[]> => {
    const { data } = await api.get('/branchoffices/')
    return data
  },

  getById: async (id: number): Promise<BranchOffice> => {
    const { data } = await api.get(`/branchoffices/${id}`)
    return data
  },

  create: async (branch: BranchFormData): Promise<BranchOffice> => {
    const payload = {
      ...branch,
      id_company: Number(localStorage.getItem('id_company') ?? 1),
    }
    const { data } = await api.post('/branchoffices/', payload)
    return data
  },

  update: async (id: number, branch: BranchFormData): Promise<BranchOffice> => {
    const { data } = await api.put(`/branchoffices/${id}`, branch)
    return data
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/branchoffices/${id}`)
  },
}
